<template>
  <div class="side-menu" v-if="open">
    <div class="sidebar-title">
        <slot name="title"></slot>
    </div>
    <div class="sidebar-content">
        <slot name="content"></slot>
    </div>
    <hr class="m-0" />
    <div class="sidebar-footer">
        <button
            class="sidebar-btn"
            @click="ClearFilters"
        >
            LIMPAR
        </button>
        <button
            class="sidebar-btn"
            @click="ApplyFilters"
        >
            APLICAR
        </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideBar',
  props: {
    open: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    ClearFilters() {
        this.$emit('clear-filters')
    },
    ApplyFilters() {
        this.$emit('apply-filters')
    }
  }
}
</script>

<style lang="scss" scoped>
.side-menu {
    width: 25%;
    min-width: 220px;
    max-width: 25%;
    height: 100%;
    box-shadow: 2px 0 8px var(--boxShadowColor);
    display: flex;
    flex-direction: column;
    z-index: 10;
    transition: width 0.3s;
    background: var(--sideBarBackgroundColor);
}

.sidebar-title {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 2.88rem;
    background: var(--barsBackground);
    font-size: 22px;
    color: var(--titleFontColor);
    font-weight: bold;
    border-bottom: 1px solid var(--separatorColor);

}

.sidebar-content {
    flex: 1;
    overflow-y: auto;
}

.sidebar-footer {
    background: var(--barsBackground);
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 3.75rem;
    padding: 10px 50px;
}

.sidebar-btn {
    background: var(--buttonPrimary);
    color: #fff;
    border: none;
    border-radius: 8px;
    font-weight: 700;
    font-size: 1rem;
    height: 90%;
    width: 48%;
    transition: background 0.2s;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: var(--buttonPrimaryHover);
    }
}
</style>